module.exports = __webpack_public_path__ + "prod/1.42.2/img/bitmap.8b53e8e8.png";